function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "constants", () => $882b6d93070905b3$export$1a988e7317c65621);
$parcel$export(module.exports, "TimeBetweenDateAndNow", () => $7a4f30ddfd92e362$export$9fd8252660d26241);
$parcel$export(module.exports, "TimeBetweenDates", () => $87b8c7e81239af03$export$465d77ce3a157adf);
$parcel$export(module.exports, "TimeDuration", () => $1f9361f71cd4f493$export$df1624bc750a5bc5);
// https://github.com/parcel-bundler/parcel/issues/5911
var $af8d31735c159a26$exports = {};

$parcel$export($af8d31735c159a26$exports, "msToDay", () => $af8d31735c159a26$export$5e2ecad62a13c2ad);
$parcel$export($af8d31735c159a26$exports, "msToHour", () => $af8d31735c159a26$export$41e93d987d114964);
$parcel$export($af8d31735c159a26$exports, "msToMinute", () => $af8d31735c159a26$export$2d874d95ab51c27);
$parcel$export($af8d31735c159a26$exports, "msToSecond", () => $af8d31735c159a26$export$a71b2021a713c190);
const $af8d31735c159a26$export$5e2ecad62a13c2ad = 86400000;
const $af8d31735c159a26$export$41e93d987d114964 = 3600000;
const $af8d31735c159a26$export$2d874d95ab51c27 = 60000;
const $af8d31735c159a26$export$a71b2021a713c190 = 1000;




const $a174154c79c0dae5$var$units = [
    {
        type: "day",
        property: "days",
        msToUnit: (0, $af8d31735c159a26$export$5e2ecad62a13c2ad),
        order: 0
    },
    {
        type: "hour",
        property: "hours",
        msToUnit: (0, $af8d31735c159a26$export$41e93d987d114964),
        order: 1
    },
    {
        type: "minute",
        property: "minutes",
        msToUnit: (0, $af8d31735c159a26$export$2d874d95ab51c27),
        order: 2
    },
    {
        type: "second",
        property: "seconds",
        msToUnit: (0, $af8d31735c159a26$export$a71b2021a713c190),
        order: 3
    },
    {
        type: "millisecond",
        property: "milliseconds",
        msToUnit: 1,
        order: 4
    }
];
function $a174154c79c0dae5$export$e04e41a1e24ffd3f(keyOrUnit, ms) {
    const negative = ms < 0;
    if (negative) ms *= -1;
    const unit = typeof keyOrUnit === "string" ? $a174154c79c0dae5$var$units.find((x)=>x.type === keyOrUnit) : keyOrUnit;
    if (unit == null) throw new Error("could not find unit");
    const biggerUnits = $a174154c79c0dae5$var$units.filter((x)=>x.order < unit.order).sort((a, b)=>a.order - b.order);
    let unitValueInMs = Math.floor(ms / unit.msToUnit) * unit.msToUnit;
    for (const biggerUnit of biggerUnits)unitValueInMs -= $a174154c79c0dae5$export$e04e41a1e24ffd3f(biggerUnit.type, ms) * biggerUnit.msToUnit;
    const resultValue = Math.floor(unitValueInMs / unit.msToUnit);
    if (negative) return resultValue * -1;
    return resultValue;
}


class $373a3049474d3ce8$export$680ea196effce5f {
    getTime() {
        throw new Error("Missing implementation");
    }
    getTotalMilliseconds() {
        return this.getTime();
    }
    getTotalSeconds() {
        return this.getTime() / (0, $af8d31735c159a26$export$a71b2021a713c190);
    }
    getTotalMinutes() {
        return this.getTime() / (0, $af8d31735c159a26$export$2d874d95ab51c27);
    }
    getTotalHours() {
        return this.getTime() / (0, $af8d31735c159a26$export$41e93d987d114964);
    }
    getTotalDays() {
        return this.getTime() / (0, $af8d31735c159a26$export$5e2ecad62a13c2ad);
    }
    _getDays(time) {
        return (0, $a174154c79c0dae5$export$e04e41a1e24ffd3f)("day", time);
    }
    getDays() {
        return this._getDays(this.getTime());
    }
    _getHours(time) {
        return (0, $a174154c79c0dae5$export$e04e41a1e24ffd3f)("hour", time);
    }
    getHours() {
        return this._getHours(this.getTime());
    }
    _getMinutes(time) {
        return (0, $a174154c79c0dae5$export$e04e41a1e24ffd3f)("minute", time);
    }
    getMinutes() {
        return this._getMinutes(this.getTime());
    }
    _getSeconds(time) {
        return (0, $a174154c79c0dae5$export$e04e41a1e24ffd3f)("second", time);
    }
    getSeconds() {
        return this._getSeconds(this.getTime());
    }
    _getMilliseconds(time) {
        return (0, $a174154c79c0dae5$export$e04e41a1e24ffd3f)("millisecond", time);
    }
    getMilliseconds() {
        return this._getMilliseconds(this.getTime());
    }
    getAllTime() {
        const t = this.getTime();
        return {
            days: this._getDays(t),
            hours: this._getHours(t),
            minutes: this._getMinutes(t),
            seconds: this._getSeconds(t),
            milliseconds: this._getMilliseconds(t)
        };
    }
}


class $841f02f006dda961$export$580ea1a0b929494c extends (0, $373a3049474d3ce8$export$680ea196effce5f) {
    get fromDate() {
        throw new Error("Missing implementation");
    }
    get toDate() {
        throw new Error("Missing implementation");
    }
    getTime() {
        return this.toDate.getTime() - this.fromDate.getTime();
    }
}


class $7a4f30ddfd92e362$export$9fd8252660d26241 extends (0, $841f02f006dda961$export$580ea1a0b929494c) {
    constructor(date){
        super();
        this.date = date;
    }
    get fromDate() {
        return new Date();
    }
    get toDate() {
        return this.date;
    }
    set toDate(date) {
        this.date = date;
    }
}



class $87b8c7e81239af03$export$465d77ce3a157adf extends (0, $841f02f006dda961$export$580ea1a0b929494c) {
    constructor(a, b){
        super();
        this.dateA = a;
        this.dateB = b;
    }
    get fromDate() {
        return this.dateA;
    }
    set fromDate(a) {
        this.dateA = a;
    }
    get toDate() {
        return this.dateB;
    }
    set toDate(b) {
        this.dateB = b;
    }
}




class $1f9361f71cd4f493$export$df1624bc750a5bc5 extends (0, $373a3049474d3ce8$export$680ea196effce5f) {
    constructor(milliseconds){
        super();
        this.milliseconds = milliseconds;
    }
    getTime() {
        return this.milliseconds;
    }
    setTime(milliseconds) {
        return this.milliseconds = milliseconds;
    }
    setTotalMilliseconds(ms) {
        this.setTime(ms);
    }
    setTotalSeconds(secs) {
        this.setTime(secs * (0, $af8d31735c159a26$export$a71b2021a713c190));
    }
    setTotalMinutes(mins) {
        this.setTime(mins * (0, $af8d31735c159a26$export$2d874d95ab51c27));
    }
    setTotalHours(hours) {
        this.setTime(hours * (0, $af8d31735c159a26$export$41e93d987d114964));
    }
    setTotalDays(days) {
        this.setTime(days * (0, $af8d31735c159a26$export$5e2ecad62a13c2ad));
    }
    _setDays(days, time) {
        return time - this._getDays(time) * (0, $af8d31735c159a26$export$5e2ecad62a13c2ad) + days * (0, $af8d31735c159a26$export$5e2ecad62a13c2ad);
    }
    setDays(days) {
        this.setTime(this._setDays(days, this.getTime()));
    }
    _setHours(hours, time) {
        return time - this._getHours(time) * (0, $af8d31735c159a26$export$41e93d987d114964) + hours * (0, $af8d31735c159a26$export$41e93d987d114964);
    }
    setHours(hours) {
        this.setTime(this._setHours(hours, this.getTime()));
    }
    _setMinutes(minutes, time) {
        return time - this._getMinutes(time) * (0, $af8d31735c159a26$export$2d874d95ab51c27) + minutes * (0, $af8d31735c159a26$export$2d874d95ab51c27);
    }
    setMinutes(minutes) {
        this.setTime(this._setMinutes(minutes, this.getTime()));
    }
    _setSeconds(seconds, time) {
        return time - this._getSeconds(time) * (0, $af8d31735c159a26$export$a71b2021a713c190) + seconds * (0, $af8d31735c159a26$export$a71b2021a713c190);
    }
    setSeconds(seconds) {
        this.setTime(this._setSeconds(seconds, this.getTime()));
    }
    _setMilliseconds(milliseconds, time) {
        return time - this._getMilliseconds(time) + milliseconds;
    }
    setMilliseconds(milliseconds) {
        this.setTime(this._setMilliseconds(milliseconds, this.getTime()));
    }
    setAllTime(obj, reset) {
        if (reset) this.setTime(0);
        let t = this.getTime();
        if (obj.days != null) t = this._setDays(obj.days, t);
        if (obj.hours != null) t = this._setHours(obj.hours, t);
        if (obj.minutes != null) t = this._setMinutes(obj.minutes, t);
        if (obj.seconds != null) t = this._setSeconds(obj.seconds, t);
        if (obj.milliseconds != null) t = this._setMilliseconds(obj.milliseconds, t);
        return this.setTime(t);
    }
}


const $882b6d93070905b3$export$1a988e7317c65621 = $af8d31735c159a26$exports;


//# sourceMappingURL=index.js.map
